import React from 'react';
import { ImagesProvider } from 'contexts/ImagesContext';
import ButtonLogout from 'components/fragments/ButtonLogout2/ButtonLogout';
const ButtonLogoutComponent = (props) => (
  <ImagesProvider
    intro={false}
    r={require.context(
      'components/fragments/ButtonLogout2/',
      true,
      /\.(png|jpe?g|svg|gif)$/
    )}
  >
    <ButtonLogout {...props} />
  </ImagesProvider>
);

export default ButtonLogoutComponent;
